module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rulerX",
    attrs: {
      "id": "ruleX"
    }
  }, _vm._l((_vm.rulerInches), function(inch) {
    return _c('div', {
      staticClass: "inch"
    }, [_c('div', {
      staticClass: "val"
    }, [_c('label', [_vm._v(_vm._s(inch))])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a2d95a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportDesign/RulerX.vue
// module id = 668
// module chunks = 0